import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';

import classes from 'components/Dashboards/Portfolio/PortfolioOverview/PortfolioOverview.module.scss';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

export const ProjectCell = ({ title = '', versionHashCode = '' }) => {
    return (
        <div className={classes.projectCell}>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={<div>{title}</div>}
                triggerElement={
                    <Link
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_EXECUTION_PATH,
                            executionConfig.statusSummary.link,
                            versionHashCode,
                        )}
                    >
                        {title}
                    </Link>
                }
            />
        </div>
    );
};
